import { render, staticRenderFns } from "./VerifyEmail.vue?vue&type=template&id=533e2f9b&scoped=true&lang=pug&"
import script from "./VerifyEmail.vue?vue&type=script&lang=js&"
export * from "./VerifyEmail.vue?vue&type=script&lang=js&"
import style0 from "./VerifyEmail.scss?vue&type=style&index=0&id=533e2f9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533e2f9b",
  null
  
)

export default component.exports